<app-section-header [title]="'Edit list content'" [isBackBtnShown]="true">
  <div class="flex justify-end flex-1">
    <button
      *ngIf="displayDeleteButton"
      mat-flat-button
      color="delete"
      class="ml-3"
      [disabled]="
        deleteSubmitted ||
        submitted ||
        contentListStateService.isContentListChanged()
      "
      (click)="openDeleteContentListDialog(contentList?.id)"
    >
      <span *ngIf="deleteSubmitted">Deleting...</span>
      <span *ngIf="!deleteSubmitted">Delete</span>
    </button>
    <button
      mat-flat-button
      color="primary"
      class="w-1/4 ml-3"
      [disabled]="!contentListStateService.isContentListChanged() || submitted"
      (click)="updateContentListWithConcurrencyValidation(contentList?.id)"
    >
      <span *ngIf="submitted">Publishing...</span>
      <span *ngIf="!submitted">Publish</span>
    </button>
  </div>
</app-section-header>
<div
  class="flex h-20 mb-5 text-lg font-medium border bg-project-900 border-project-1000 font-montserrat content-list_title"
  *ngIf="contentList"
>
  <div
    *ngIf="!isEditTitle"
    class="flex items-center flex-1 pt-0 pl-2 space-x-2"
  >
    <span matTooltip="Content list name"
      >{{ contentListNamePrefix }}:
      {{ form.get(FORM_PATHS.NAME()).value }}</span
    >
    <button mat-icon-button (click)="toggleEditTitle()">
      <i class="text-xl icon icon-pencil-square-o"></i>
    </button>
  </div>

  <form
    class="flex items-center flex-1 pt-0 pl-2 space-x-2"
    (keydown.enter)="$event.preventDefault()"
    [formGroup]="form"
    *ngIf="isEditTitle"
  >
    <span matTooltip="Content list name">{{ contentListNamePrefix }}: </span>
    <mat-form-field class="w-80" [floatLabel]="'never'" appearance="outline">
      <input matInput [formControl]="form.get(FORM_PATHS.NAME())" />
    </mat-form-field>
    <button mat-icon-button (click)="toggleEditTitle()">
      <i class="text-xl icon icon-pencil-square-o"></i>
    </button>
  </form>
  <div class="inline-flex items-center float-right text-base font-normal">
    <div
      *ngIf="displayCode"
      class="inline-flex float-right text-base font-normal"
    >
      <span class="pt-2 text-center" matTooltip="Content list code for Globe">{{
        contentListCode
      }}</span>
      <button
        mat-icon-button
        (click)="copyContentListCodeToClipboard()"
        matTooltip="Copy code to clipboard"
      >
        <i class="text-xl icon icon-copy"></i>
      </button>
    </div>
    <button
      mat-icon-button
      (click)="toggleDisplayCode()"
      [matTooltip]="getContentListCodeTooltip()"
    >
      <i class="text-xl icon icon-code"></i>
    </button>
  </div>
</div>

<mat-tab-group mat-align-tabs="start">
  <mat-tab label="Content">
    <div class="flex flex-wrap justify-between gap-2">
      <div class="basis-[49%] flex-1 max-w-[49%]">
        <app-add-content-list
          [contentListCode]="contentList?.id"
          [deliveryTargetCodes]="contentList?.deliveryTargetCodes"
          (triggerAddToContentList)="triggerAddToContentList($event)"
          (triggerPinAndAddToContentList)="
            triggerPinAndAddToContentList($event)
          "
          *ngIf="contentList"
        >
        </app-add-content-list>
      </div>
      <div class="basis-[49%] flex-1 max-w-[49%]">
        <app-view-content-list
          [contentListCode]="contentList?.id"
          *ngIf="contentList"
          (triggerUpdateAddContentListData)="
            triggerUpdateAddContentListData($event)
          "
        >
        </app-view-content-list>
      </div>
    </div>
  </mat-tab>

  <mat-tab label="Tags" *ngIf="!isDefaultList">
    <app-topics-on-content-list
      [contentList]="contentList"
      (triggerTopicChangeToContentList)="
        triggerTopicChangeToContentList($event)
      "
      (triggerTagChangeToContentList)="triggerTagChangeToContentList($event)"
      (triggerTopicChangeToContentList)="
        triggerTopicChangeToContentList($event)
      "
      *ngIf="contentList"
    >
    </app-topics-on-content-list>
  </mat-tab>
</mat-tab-group>
<ng-template #formChangeWarn>
  <h2 matDialogTitle>Discard changes?</h2>
  <div mat-dialog-content>
    Changes have been made.
    <br />
    Are you sure you want to continue without saving them?
  </div>
  <div mat-dialog-actions class="mt-5">
    <div class="flex-1"></div>
    <button mat-button mat-dialog-close class="mr-3">Cancel</button>
    <button mat-flat-button (click)="navigateAway()" color="primary">
      Yes
    </button>
  </div>
</ng-template>
